import TNMLogo from '../../../styles/images/svg/TNM_Sticker4_DarkGrey+Yellow.svg';

export const WhyChooseUs = () => (
  <div className="why-choose-us tnm-v1">
    <main className="main">
      <section className="page-hero">
        <div className="page-header">
          <div className="header-text-block">
            <h1>Why Choose Us?</h1>
          </div>
        </div>
        <div className="page-header-right"></div>
        <div className="hero-stamp">
          <img src={TNMLogo} alt="" className="image" />
        </div>
      </section>
    </main>
  </div>
);
